import { css,html, LitElement, nothing } from 'lit';
import { customElement } from 'lit/decorators.js';
import '@vaadin/vaadin';

import { bootstrap } from './bootstrap/bootstrap';
import { resolveView } from './router';
import './views/combined-view/combined-view';
import './views/last-values/last-values-view';
import './views/alarmstatus-view/alarmstatus-view';
import './views/multigraph-view/multigraph-view';
import './components/ki-ds-pwa-menu/ki-ds-pwa-menu';
import './components/ki-ds-pwa-footer/ki-ds-pwa-footer';

@customElement('root-element')
class RootElement extends LitElement {
    static styles = css`
        :host {
            display: flex;
            flex-direction: column;
            height: 100vh;
        }

        .app-content {
            flex: 1;
            min-height: 0;
            overflow: hidden;
        }
    `;

    static get properties() {
        return {
            isReady: { type: Boolean },
            channel: { type: Object },
            kioskMode: { type: Boolean },
        };
    }

    constructor() {
        super();
        this.isReady = false;
        this.channel = null;
        this.kioskMode = new URLSearchParams(window.location.search).has('kiosk');
    }

    connectedCallback() {
        super.connectedCallback();
        this.addEventListener('channel-loaded', (e) => {
            this.channel = e.detail.channel;
        });
    }

    async firstUpdated() {
        bootstrap();
        this.isReady = true;
    }

    render() {
        if (!this.isReady) {
            return html` <div
                    style="display: flex; justify-content: center; align-items: center; min-height: 90.5vh; width: 100%;"
                >
                    <img
                        src="assets/loading-icon.png"
                        alt="Loading Icon"
                        style="width: 100px; height: 100px; animation: spin 2s linear infinite;"
                    />
                </div>
                <style>
                    @keyframes spin {
                        0% {
                            transform: rotate(0deg);
                        }
                        100% {
                            transform: rotate(360deg);
                        }
                    }
                </style>`;
        }
        return html`
            ${!this.kioskMode
                ? html`<ki-ds-pwa-menu .channel=${this.channel}></ki-ds-pwa-menu>`
                : nothing}
            <div class="app-content">${resolveView(this)}</div>
            ${!this.kioskMode ? html`<ki-ds-pwa-footer></ki-ds-pwa-footer>` : nothing}
        `;
    }
}
